import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MceSettings } from 'app/core/mce-config/mce-editor-config.constant';
import { NotificationBulkSendInterface, NotificationInterface, NotificationTemplate, NotificationTemplateInterface } from 'app/notifications/models';
import { NotificationService } from 'app/notifications/services/notification.service';
import { sortNotificationItemsByTitle } from 'app/shared/utilities/object-sort-methods.utility';
import { stringDecodeToHtml } from 'app/shared/utilities/utility-methods.utility';
import { environment } from 'environments/environment.prod';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cz-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
})
export class NotificationDialogComponent implements OnInit {

  public notification: NotificationInterface;
  public notificationTemplates: NotificationTemplateInterface[] = [];
  public selectedTemplate: NotificationTemplateInterface;
  public sendTemplate: boolean = false;
  public notificationSendFormGroup: FormGroup;
  public notificationTemplateControl: FormControl;
  public today: Date;
  public tinyApiKey: string = environment.tinyMceKey;
  public descriptionDisplayConfig: any = MceSettings.readonlyDisplay;
  public descriptionControl: FormControl = new FormControl('');


  private readonly _destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly _notificationService: NotificationService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private readonly _dialogRef: MatDialogRef<NotificationDialogComponent>) {

    this.initializeReactiveForm();

    // Load relevant data.
    this._notificationService.getNotificationTemplates()
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe((notificationTemplates: NotificationTemplateInterface[]) => {
        this.notificationTemplates = sortNotificationItemsByTitle(notificationTemplates);
      });
  }

  public ngOnInit(): void {
    if(this.data.userIds) {
      this.sendTemplate = true;
      this.notificationTemplateControl.valueChanges.pipe(
        takeUntil(this._destroy$),
      ).subscribe((notificationTemplate: NotificationTemplateInterface) => {
        this.selectedTemplate = new NotificationTemplate(notificationTemplate);
        this.descriptionControl.patchValue(stringDecodeToHtml(this.selectedTemplate.templateText));
      });
    } else {
      this.notification = this.data.notification;
      this.descriptionControl.patchValue(this.notification.messageAsHtml);
    }
  }

  public sendNotification(): void {
    if(this.selectedTemplate) {
      const sendData: NotificationBulkSendInterface = {
        templateId: this.selectedTemplate.id,
        recipientIds: this.data.userIds,
      };

      this._notificationService.sendNotifications(sendData);

      this._dialogRef.close();
    }
  }

  private initializeReactiveForm(): void {
    this.notificationTemplateControl = new FormControl({ value: '' }, Validators.required);

    this.notificationSendFormGroup = new FormGroup({
      notifcationTemplateCtrl: this.notificationTemplateControl,
    });

    this.today = new Date(Date.now());
  }
}
